export default "__VITE_PUBLIC_ASSET__70aa88ce__"